type DateValue = string | number | Date;
const dateOptions: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
/**
 * Format a date in Australian day/month/year order.
 *
 * Args:
 *   value: Date object, timestamp, or ISO date string.
 * Returns:
 *   A padded DD/MM/YYYY date, or an em dash for invalid input.
 */
export function formatDate(value: DateValue): string {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('en-AU', dateOptions);
}
/**
 * Format an Australian date with local hours and minutes.
 *
 * Args:
 *   value: Date object, timestamp, or ISO date string.
 * Returns:
 *   A date and local time, or an em dash for invalid input.
 */
export function formatDateTime(value: DateValue): string {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : `${formatDate(date)}, ${date.toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' })}`;
}
